module.exports = __webpack_public_path__ + "img/guy.75e7eee9.svg";